// History carries an ET calendar-date key, not a browser-local timestamp.
export function huntNightLabel(key) {
  if (typeof key !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(key)) return 'Night date unavailable'
  const date = new Date(`${key}T12:00:00.000Z`)
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== key) return 'Night date unavailable'
  return date.toLocaleDateString('en-US', {timeZone:'UTC',weekday:'short',month:'short',day:'numeric',year:'numeric'})
}
